import React from "react";
const agentMessages = {
  "Intake Review Agent": (
    <>
      <strong> Need help</strong> reviewing <strong>applications</strong>? I can  <strong>identify potential duplicate</strong> submissions.
    </>
  ),

  "Benefits Agent": (
    <>
      Need help <strong>reviewing applications? I can identify </strong> potential <strong> duplicate benefits </strong> and <strong>flag compliance risks.</strong>
    </>
  ),

  "Eligibility Review Agent": (
    <>
      Need help <strong>reviewing applications? I can check eligibility </strong>and  <strong> flag any issues.</strong>
    </>
  ),

  "Application Status Agent": (
    <>
      <strong> Need </strong> help <strong>reviewing applications?</strong> I can <strong>  provide the status</strong> of any application.
    </>
  ),

  "Document Quality Agent": (
    <>
      Need help <strong>reviewing applications?</strong> I can <strong> check document quality</strong> and 
      {' '}
<strong> flag any issues.</strong>
    </>
  )
};

const formatNameFromEmail = (email) => {
  if (!email) return "";

  const localPart = email.split("@")[0];
  const parts = localPart.split(/[.\-_]/g);

  return parts
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(" ");
};

const AgentMessage = ({ userName, agentName, logedInUserMail }) => {
  const displayName = formatNameFromEmail(logedInUserMail);

  return (
    <div className="agent-message center-content">
      <h3>
        Hello,
        {' '}
        {displayName}
        {' '}
        👋
      </h3>
      <p>{agentMessages[agentName]}</p>
    </div>
  );
};

export default AgentMessage;
